export default "__VITE_ASSET__DJ27o9UE__"